module.exports = __webpack_public_path__ + "img/geofisica_16-9_1920.7e4dea01.webp";